import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { LoaderService } from '@teem/services/loader.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { UserService } from '@teem/services/user.service';
import { messages as i18n } from '@teem/constants/messages';
declare var $;

@Component({
	selector: 'oto-tab',
	templateUrl: './oto-tab.component.html',
	styleUrls: []
})
export class OtoTabComponent implements OnInit {
	// @Output() public updateUserDetails = new EventEmitter();
	// @Output() public goToPlan = new EventEmitter();
	@Input() otoAccountType;
	submitted: boolean = false;
	userDetails: any = null;
	labelStatus: string = 'default_show';
	merchantForm: FormGroup;
	creditAmount: number = 0;
	accountType: any = [{ 'id': 'new_account', 'name': $localize`:@@ts.common.new_account:New Account` }, { 'id': 'existing_account', 'name': $localize`:@@ts.common.existing_account:Existing Account` }];
	selectedAccountType : any = { 'id': 'new_account', 'name': $localize`:@@ts.common.new_account:New Account` };

	constructor(
		private fb: FormBuilder,
		private loaderService: LoaderService,
		private userService: UserService,
		private sharedDataService: SharedDataService,
		private cdr: ChangeDetectorRef, 

	) { }

	@Input('userDetails')	
	set getInfo(val: any) {
		this.userDetails = val;		
		this.creditAmount = this.userDetails?.oto_info?.oto_credit ? this.userDetails?.oto_info?.oto_credit : 0;
		if (this.userDetails?.subscription.subscription_status == 'free') {
			this.labelStatus = 'free_user';
		} else {
			this.labelStatus = 'paid_user';
		}
	}

	get f() {
		return this.merchantForm.controls;
	}

	ngOnInit(): void {
		this.merchantForm = this.fb.group({
			account_type: [this.otoAccountType, Validators.required],
			company_name: [this.userDetails ? this.userDetails?.business_name : '', Validators.required],
			email: [this.userDetails ? this.userDetails?.email : '', Validators.required],
			full_name: [this.userDetails ? this.userDetails?.full_name : '', Validators.required],
			mobile_number: [this.userDetails ? this.userDetails?.phone : '', Validators.required],
			cr_number: [this.userDetails ? this.userDetails?.tax_number : '', Validators.required],
			vat_number: [this.userDetails ? this.userDetails?.tax_number : '', Validators.required],
			city: [this.userDetails ? this.userDetails?.city : '', Validators.required],
			billing_address: [this.userDetails ? this.userDetails?.address : '', Validators.required],
			pickup_address: [this.userDetails ? this.userDetails?.address : '', Validators.required],
			refresh_token: [''],
		});
	}
	
	ngAfterViewInit() {
		this.onChangeAccountType(this.otoAccountType);
		setTimeout(() => {
			$('select[nice-select]').niceSelect('update');
		}, 300);
	}

	addOtoCreditAmount() {
		Swal.fire({
			title: 'OTO credit amount',
			input: 'number',
			inputPlaceholder: 'Enter credit amount',
			showCancelButton: true,
			inputValidator: function (value) {
				return new Promise(function (resolve, reject) {
					if (!value) {
						resolve('You must have to input credit amount');
					} else {
						resolve();
					}
				});
			}
		}).then((result) => {
			if (result.isConfirmed) {
				this.loaderService.startLoading();				
				let creditAmount = result.value ? result.value : '';
				this.userService.addOtoCredit(creditAmount).subscribe((data: any) => {
					this.loaderService.stopLoading();
					window.location.href = data.paymentURL;
				}, err => {
					this.loaderService.stopLoading();
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				}); 
			}
		});
	}

	fetchOtoClientInfo() {
		this.loaderService.startLoading();
		this.userService.fetchOtoClientInfo(this.userDetails.uuid).subscribe((data: any) => {
		  this.loaderService.stopLoading();
		  this.creditAmount = data.oto_credit;
		}, err => {
		  this.loaderService.stopLoading();
		  Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
		});    
	}

	onSubmit(form: FormGroup) {
		this.submitted = true;
		if (form.valid) {
			this.loaderService.startLoading();
			this.userService.addMerchantInfo('oto', form.value).subscribe(
				(res: any) => {
					this.loaderService.stopLoading();

					// Update parent user
					this.userDetails = res.user;
					// this.updateUserDetails.emit(this.userDetails);

					// Update app basic info for user
					let userInfo = this.sharedDataService.getItem('userInfo');
					if (userInfo != undefined) {
						userInfo = this.userDetails;
						this.sharedDataService.setItem('userInfo', userInfo);
					}

					Swal.fire(i18n.done, 'Thank you for entering your details, You will redirect to activation page. Please activate account following to redirected URL.', 'success').then(result => {
						if(result.value){
							if (res?.data?.activationLink) {
								window.window.location.href = res.data.activationLink;
							}
						}
					});					
				},
				(err) => {
					this.loaderService.stopLoading();
					if (err.status === 422) {
						if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
							let validationErrors = err.error.errors;
							Object.keys(validationErrors).forEach((prop) => {
								this.merchantForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					}

					let msg = err?.error?.data?.errorMsg ? err?.error?.data?.errorMsg : i18n.getError(err);
					Swal.fire(i18n.alert.error, msg, 'error');
				}
			)
		}
	}

	editForm() {
		this.loaderService.startLoading();
		setTimeout(() => {
			this.loaderService.stopLoading();
			this.merchantForm.get('account_type').setValue(this.userDetails?.oto_info?.account_type);
			this.merchantForm.get('company_name').setValue(this.userDetails?.oto_info?.company_name);
			this.merchantForm.get('email').setValue(this.userDetails?.oto_info?.email);
			this.merchantForm.get('full_name').setValue(this.userDetails?.oto_info?.full_name);
			this.merchantForm.get('mobile_number').setValue(this.userDetails?.oto_info?.mobile_number);
			this.merchantForm.get('cr_number').setValue(this.userDetails?.oto_info?.cr_number);
			this.merchantForm.get('vat_number').setValue(this.userDetails?.oto_info?.vat_number);
			this.merchantForm.get('city').setValue(this.userDetails?.oto_info?.city);
			this.merchantForm.get('billing_address').setValue(this.userDetails?.oto_info?.billing_address);
			this.merchantForm.get('pickup_address').setValue(this.userDetails?.oto_info?.pickup_address);
			this.merchantForm.get('refresh_token').setValue(this.userDetails?.oto_info?.refresh_token);
			
			this.merchantForm.get('refresh_token').clearValidators();
			this.merchantForm.get('refresh_token').updateValueAndValidity();
			if (this.userDetails?.oto_info?.account_type == 'new_account') {
				this.selectedAccountType = { 'id': 'new_account', 'name': 'New Account' };
			} else {
				this.selectedAccountType = { 'id': 'existing_account', 'name': 'Existing Account' };
				this.merchantForm.get('refresh_token').setValidators([Validators.required]);
        		this.merchantForm.get('refresh_token').updateValueAndValidity();
			}

			this.userDetails.is_oto_info = false;
		}, 100);

		setTimeout(() => {
			$('select[nice-select]').niceSelect('update');
		}, 300);
	}

	onChangeAccountType(id) {
		this.merchantForm.get('refresh_token').setValue(this.userDetails?.oto_info?.refresh_token);
		this.merchantForm.get('refresh_token').clearValidators();
		this.merchantForm.get('refresh_token').updateValueAndValidity();

		if (id == 'new_account') {
			this.selectedAccountType = { 'id': 'new_account', 'name': 'New Account' };
		} else {
			this.selectedAccountType = { 'id': 'existing_account', 'name': 'Existing Account' };
			this.merchantForm.get('refresh_token').setValidators([Validators.required]);
        	this.merchantForm.get('refresh_token').updateValueAndValidity();
		}

		this.cdr.detectChanges();
		setTimeout(() => {
			$('select[nice-select]').niceSelect('update');
		}, 2000);
	}

	updateStatus(uuid, event: any) {
		let checked = event.target.checked;
		this.userDetails.accept_oto = !checked;
		Swal.fire({
			title: i18n.are_you_sure,
			text: i18n.you_want_to_update_status,
			icon: 'info',
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: false,
			confirmButtonText: i18n.yes,
			cancelButtonText: i18n.no_cancel_it
		}).then(result => {
			if (result.value) {
				let fd: any = {};
				fd.uuid = uuid;
				fd.type = 'oto';
				this.loaderService.startLoading();
				this.userService.updateStatus(fd).subscribe((data: any) => {
					this.loaderService.stopLoading();
					event.target.checked = checked;
					this.userDetails.accept_oto = !checked;
					setTimeout(function () {
						Swal.fire(i18n.done, i18n.status_updated_successfully, 'success');
					}, 0);

				}, err => {
					this.loaderService.stopLoading();
					event.target.checked = !checked;
					this.userDetails.accept_oto = checked;
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				})
			}else{
				event.target.checked = !checked;
				this.userDetails.accept_oto = checked;
				return false;
			}
		});
	}

	goBack() {
		this.userDetails.is_oto_info = true;
	}

}
